import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-af7007f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "user",
  class: "view"
}
const _hoisted_2 = { class: "box" }

import {
    ComputedRef,
    computed,
    onBeforeMount,
    onBeforeUnmount,
    toRefs,
  } from 'vue'
  import { useRoute } from 'vue-router'

  import UserHeader from '@/components/User/ProfileDisplay/UserHeader.vue'
  import UserInfos from '@/components/User/ProfileDisplay/UserInfos.vue'
  import { USERS_STORE } from '@/store/constants'
  import { IUserProfile } from '@/types/user'
  import { useStore } from '@/use/useStore'

  interface Props {
    fromAdmin: boolean
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    fromAdmin: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    fromAdmin: boolean
  }

  
  const { fromAdmin } = toRefs(props)

  const route = useRoute()
  const store = useStore()

  const user: ComputedRef<IUserProfile> = computed(
    () => store.getters[USERS_STORE.GETTERS.USER]
  )

  onBeforeMount(() => {
    if (route.params.username && typeof route.params.username === 'string') {
      store.dispatch(USERS_STORE.ACTIONS.GET_USER, route.params.username)
    }
  })

  onBeforeUnmount(() => {
    store.dispatch(USERS_STORE.ACTIONS.EMPTY_USER)
  })

return (_ctx: any,_cache: any) => {
  return (_unref(user).username)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(UserHeader, { user: _unref(user) }, null, 8, ["user"]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(UserInfos, {
            user: _unref(user),
            "from-admin": _unref(fromAdmin)
          }, null, 8, ["user", "from-admin"])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})